/*
 *  Return timestamp of today, tomorrow, yesterday
 * */
const getDays = (startTime: number | null) => {
  const q = startTime ? new Date(startTime * 1000) : new Date();
  const m = q.getMonth();
  const d = q.getDate();
  const y = q.getFullYear();
  let today = +new Date(y, m, d);
  today /= 1000;
  const tomorrow = today + 86400;
  const yesterday = today - 86400;

  return {
    today,
    tomorrow,
    yesterday,
  };
};

/*
 *  Return date, if interval (today || tomorrow || yesterday) is given
 *  Return redirect if date is given
 * */
export const getDateByInterval = (interval: string, startTime: number) => {
  const { today, tomorrow, yesterday } = getDays(startTime);

  if (interval === 'today' || interval === 'live' || !interval) {
    return new Date(today * 1000);
  }
  if (interval === 'yesterday' || interval === 'past') {
    return new Date(yesterday * 1000);
  }
  if (interval === 'tomorrow') {
    return new Date(tomorrow * 1000);
  }

  return new Date(interval);
};
